<template>
  <div>
    <div class="common-box margin-t10">
      <el-row class="row-one">
        <span class="row-one-title">私募基金资产信息</span>
        <Reback v-show="this.$route.name !== 'myAssets'  && this.$route.name !== 'indexno'" class="row-one-fr" @click.native="returnClick"></Reback>
      </el-row>
      <el-radio-group class="radio-single-btn margin-t20" v-model="radio" size="medium">
        <el-radio-button label="1">持仓信息{{ ' ( '+holdFundTableData.length+' ) '}}</el-radio-button>
        <el-radio-button label="2">确认中{{' ( '+confirmTableData.length+' ) '}}</el-radio-button>
      </el-radio-group>
      <!-- 持仓信息 -->
      <el-table v-show="radio==1" v-loading="loading" element-loading-text="加载中..." class="table-single margin-t20" :data="holdFundTableData" ref="holdFundTableRef" style="width: 100%">
        <el-table-column label="基金名称" prop="sname" width="240">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.sname" placement="right">
              <a href="javascript:;" class="table-single-a">{{scope.row.sname}}</a>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="最新净值(仅供参考)" prop="currnav" width="150">
        </el-table-column>
        <el-table-column label="净值日期" prop="navdate">
        </el-table-column>
        <el-table-column label="当前市值" prop="curramount">
        </el-table-column>
        <el-table-column label="净购买金额" prop="costamount">
        </el-table-column>
        <el-table-column label="确认份额" prop="amountvol">
        </el-table-column>
        <el-table-column label="持有收益(元)" prop="holdIncome">
          <template slot-scope="scope">
            <span v-if="scope.row.holdIncome > 0" class="rColor">{{'+'+scope.row.holdIncome}}</span>
            <span v-else-if="scope.row.holdIncome < 0" class="gColor">{{scope.row.holdIncome}}</span>
            <span v-else>{{scope.row.holdIncome}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="tap">
          <template slot-scope="scope">
            <div v-show="scope.row.tap == '0'">--</div>
            <span v-show="scope.row" class="table-single-btn-normal" @click="dialogVisable = true">追加</span>
          </template>
        </el-table-column>

      </el-table>
      <!-- 确认中 -->
      <el-table v-show="radio==2" class="table-single margin-t20" :data="confirmTableData" ref="confirmTableRef" style="width: 100%">
        <el-table-column label="基金名称" prop="fundName" width="150">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="light" popper-class="table-single-tip" :content="scope.row.fundName" placement="right">
              <a :href="scope.row.Fundcode == null ? 'javascript:;':'https://www.myfund.com/PrivateFund/'+ scope.row.Fundcode +'.html'" class="table-single-a" :target="scope.row.Fundcode == null ?'_self':'_blank'">{{scope.row.fundName}}</a>
              <!-- <a href="javascript:;" class="table-single-a">{{scope.row.fundName}}</a> -->
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column label="交易类型" prop="businessType">
        </el-table-column>
        <el-table-column label="申请日期" prop="AddDate">
        </el-table-column>
        <el-table-column label="净购买金额" prop="Amount">
        </el-table-column>
        <el-table-column label="认/申购费" prop="Charge">
        </el-table-column>
        <el-table-column label="汇款银行卡" prop="BankName">
        </el-table-column>
        <el-table-column label="最近开放日" prop="time">
        </el-table-column>
        <el-table-column label="交易状态" prop="orderStatus">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <span v-show="scope.row.OrderNum" class="table-single-btn-normal" @click="dialogVisable = true">撤单</span>
            <div v-show="scope.row.OrderNum == null">--</div>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <!-- 功能开发中 -->
    <el-dialog class="dialog-single-one" center :visible.sync="dialogVisable1" :show-close="false">
      <img src="../../../assets/images/development.png" alt="" style="width:120px;height:110px;">
      <span slot="footer" class="dialog-footer">
        <el-button type="normal1" @click="dialogVisable1 = false">确定</el-button>
      </span>
    </el-dialog>
    <!-- 私募买入 -->
    <el-dialog class="dialog-single-four" :visible.sync="dialogVisable">
      <section class="instruction">
        <div class="dialog-single-four-adviser">
          <p class="p1">展恒顾问二维码</p>
          <img src="../../../assets/images/private_buy.png" alt="" style="width:150px;height:150px;">
          <p class="p2">请前往展恒基金app进行操作，或扫码添加展恒基金专业顾问了解产品更多详情</p>
          <p class="p3">或拨打400-818-8000客服电话咨询</p>
        </div>
      </section>
    </el-dialog>
  </div>
</template>

<script>
const Base64 = require("js-base64").Base64;
export default {
  name: "privateAssetsMessage",
  props: ['PrivatelyFloat'],
  data () {
    return {
      dialogVisable1: false,
      dialogVisable: false,
      radio: '1',
      holdFundTableData: [],
      toogle: true,
      toogleText: '展开',
      openicon: 'el-icon-arrow-down',
      confirmTableData: [],
      Cha: 0,
      tap: '0', //是否可赎回标识 0 不可以  1 可以
      comfundlist: '',
      // 子表字段
      fundType: '',
      againBuy: '',
      holdArr: [],
      loading: true,
    }
  },
  mounted () {
    this.global()
  },
  methods: {
    returnClick () {
      this.$router.push({
        name: 'privateRecord'
      })
    },
    async global() {
      await this.getPrivate()
      this.getFix()
      await this.getFloat()
      this.getconfirm()
    },
    // 私募基金
    async getPrivate () {  //资产privateTotalAssets 数量privateCount 日期privateNewDate 收益privateallSY
      await this.$http.post(this.$apiPath.getPrivatelyFloat, {
        sessionId: this.$commonJs.getCookie('sessionid'),
        fundcode: '',
        appnew: '1'
      }).then(res => {
        if (res.status !== 200) return
        if (res.data.code !== '200') return
        // console.log(res);
        if (res.data.data == null) {
          // console.log('如果无数据，固定资产');
          this.getFix()
        }
        const privateList = res.data.data.privateList
        // console.log(privateList);
        privateList.forEach(item => {
          item.sname = item.fundname
          item.navdate = this.$commonJs.getDateStrHg(item.navdate)
          item.currnav = parseFloat(item.nav).toFixed(4)
          item.curramount = item.mktvalue ? parseFloat(item.mktvalue).toFixed(2) + '元' : '--'
          item.costamount = item.buymount ? parseFloat(item.buymount).toFixed(2) + '元' : '--'
          item.amountvol = item.confirmedvol ? parseFloat(item.confirmedvol).toFixed(2) + '份' : '--'
          item.holdIncome = item.floatprofit ? parseFloat(item.floatprofit).toFixed(2) : '--'
        })
        this.holdArr = privateList
        this.getFix()
      }).catch(err => { })
    },
    // 浮动
    async getFloat () {
      //浮动资产
      await this.$http.post(this.$apiPath.selectFloatPro, {
        identify: Base64.decode(this.$commonJs.getCookie('u_id'))
      }).then(res2 => {
        // console.log('f', res2);
        this.loading = false
        if (res2.data.code !== '200') return
        if (res2.data.data) {
          this.privateallSY = 0
          const total2 = res2.data.data
          if (total2) {
            total2.forEach(item => {
              item.currnav = item.currnav.toFixed(4)
              item.holdIncome = parseFloat(item.currnav * item.amountvol - item.costamount).toFixed(2)
              item.navdate = this.$commonJs.timeFormat(item.navdate, 'yyyy-mm-dd')
              item.curramount = item.curramount ? parseFloat(item.curramount).toFixed(2) + '元' : '--'
              item.costamount = item.costamount ? parseFloat(item.costamount).toFixed(2) + '元' : '--'
              item.amountvol = item.amountvol ? parseFloat(item.amountvol).toFixed(2) + '份' : '--'
            })
            this.holdFundTableData = this.holdArr.concat(total2)
          }
        } 
      }).catch(err => { })
    },
    // 固定   无参数，无法处理
    async getFix () {
      // 固定资产
      await this.$http.post(this.$apiPath.selectFixPro, {
        identify: Base64.decode(this.$commonJs.getCookie('u_id'))//Base64.decode(	this.$commonJs.getCookie('u_id'))   110105196311255474  310103197309072037
      }).then(res1 => {
        // console.log('g', res1);
        if (res1.data.code !== '200') return
        if (res1.data.data) {
          const total = res1.data.data
          this.privateTotalAssets = 0
          for (var i = 0; i < total.length; i++) {
            this.privateCount++;
            this.privateTotalAssets += Number(total[i].amountvol)
          }
          // console.log(this.privateCount, this.privateTotalAssets);
        }
      }).catch(err => { })
    },
    // 确认中
    getconfirm () {
      this.$http.post(this.$apiPath.privateConfirmationNew, {
        certificateno: Base64.decode(this.$commonJs.getCookie('u_id')),
        mobile: this.$commonJs.getCookie('u_phone1')
      }).then(res => {
        if (res.data.code !== '200') return
        if (res.data.data) {
          const total = res.data.data
          // console.log(total);
          this.confirmTableData = total
          total.forEach(item => {
            if (item.businessType == 1) {
              item.businessType = "买入";
            } else if (item.businessType == 2) {
              item.businessType = "追加";
            } else if (item.businessType == 3) {
              item.businessType = "赎回";
            } else if (item.businessType == 4) {
              item.businessType = "撤单";
            }
            item.AddDate = item.AddDate ? item.AddDate.slice(0, 10) : '--'
            item.Amount = item.Amount ? item.Amount + '元' : '--'
            item.Charge = item.Charge ? item.Charge + '元' : '--'
            item.BankName = item.BankName ? item.BankName : '--'
            item.time = item.time ? item.time.slice(0, 10) : '--'
            if (item.Status == 0) { // 有时间纠正
              item.orderStatus = "文件审核未通过"
            } else if (item.Status == 4) {
              item.orderStatus = "划款并上传凭证"
            } else if (item.Status == 1 && item.cancelStatus == 0) {
              item.orderStatus = "划款凭证审核中"
            } else if (item.Status == 3) {
              item.orderStatus = "划款凭证审核未通过"
            } else if (item.Status == 2 && item.cancelStatus == 0) {
              item.OrderNum = null
              item.orderStatus = "管理员确认中"
            }
            // else if (item.Status == 2 && item.cancelStatus == 1 && item.ManagerConfirm == 0) {
            //   item.orderStatus = "管理人确认中"
            // }
          })
        }
      }).catch(err => { })
    },
  }
}
</script>

<style lang="less" scoped>
</style>